@if (ppSites.length === 0) {
  <div class="assetCard__noSitesText">
    {{ 'asset_no_sites' | ppTranslate }}
  </div>
}

@if (ppSites.length > 0) {
  <pp-asset-card-sites-table
    class="assetCard__sitesTable"
    [ppSites]="ppSites"
  ></pp-asset-card-sites-table>
}
